const CKEDITOR_CONF = {
  height: 500,
  removePlugins: 'elementspath,resize',
  toolbar: [
    ['Font', 'Format', 'FontSize', 'Bold', 'Italic', 'Underline', 'Strike', 'TextColor', 'Subscript', 'Superscript', 'Blockquote'],
    ['JustifyLeft', 'JustifyCenter', 'JustifyRight', 'JustifyBlock'],
    ['Table', 'Image'],
  ],
  enterMode: 2,
  shiftEnterMode: 1,
  versionCheck: false,
};

export default CKEDITOR_CONF;
